import React, { useState } from 'react';

const AncienAmbassadorSection = () => {
  const [showAll, setShowAll] = useState(false);

  // Données des anciens ambassadeurs
  const ambassadors = [
    {
      period: "31 août 2020 . 11 juillet 2023",
      name: "M. Eusèbe AGBANGLA"
    },
    {
      period: "15 septembre 2008 . 05 mai 2013",
      name: "M. Albert AGOSSOU"
    },
    {
      period: "15 novembre 2016 . 31 juillet 2020",
      name: "M. Auguste ALAVO"
    },
    {
      period: "18 décembre 2003 . 13 décembre 2007",
      name: "M. Edgar-Yves MONNOU"
    },
    {
      period: "13 mai 2013 . 31 octobre 2016",
      name: "M. Jules-Armand ANIAMBOSSOU"
    },
    {
      period: "12 novembre 1996 . 05 mai 2003",
      name: "M. André-Guy OLOGOUDOU"
    },
    {
      period: "14 septembre 1994 . 05 septembre 1996",
      name: "M. Richard ADJAHO"
    },
    {
      period: "17 octobre 1990 . 21 mai 1994",
      name: "M. Cyrille SAGBO"
    },
    {
      period: "16 septembre 1982 . 10 août 1990",
      name: "M. Idrissou Souler ISSIFOU"
    },
    {
      period: "29 janvier 1976 . 12 juin 1982",
      name: "M. Médé Moussa YAYA"
    },
    {
      period: "23 mars 1973 . 31 octobre 1975",
      name: "M. Wilfrid de SOUZA"
    },
    {
      period: "13 septembre 1971 . 12 mars 1973",
      name: "M. Daouda BADAROU"
    },
    {
      period: "29 avril 1967 . 17 juin 1971",
      name: "M. Michel AHOUNMENOU"
    },
    {
      period: "20 juin 1964 . 15 mars 1967",
      name: "M. Emile POSSON"
    },
    {
      period: "21 septembre 1962 . 18 janvier 1964",
      name: "M. Sourou Migan APITHY"
    }
  ];

  // Afficher seulement les 6 premiers par défaut, ou tous si showAll est true
  const displayedAmbassadors = showAll ? ambassadors : ambassadors.slice(0, 6);

  return (
    <section className="section-ancien-ambassadeur">
      <div className="title">
        <span>ANCIENS AMBASSADEURS DU BÉNIN EN FRANCE</span>
      </div>
      
      <div className={`content-list-ambassadeur ${showAll ? 'show' : ''}`} id="list-ambassadeur">
        {displayedAmbassadors.map((ambassador, index) => (
          <div key={index} className="card-details">
            <div className="img">
              <img 
                src="https://paris.diplomatie.bj/images/icon_illustration_ambassade.svg" 
                loading="lazy" 
                alt="Icône ambassadeur" 
              />
            </div>
            <div className="info-amba">
              <span>{ambassador.period}</span>
              <span>{ambassador.name}</span>
            </div>
          </div>
        ))}
      </div>
      
      <div className="content-btn">
        {!showAll ? (
          <button 
            className="btn-see-all" 
            id="showList"
            onClick={() => setShowAll(true)}
          >
            Voir la liste
          </button>
        ) : (
          <button 
            className="btn-see-all" 
            id="hideList"
            onClick={() => setShowAll(false)}
          >
            Fermer <i className="fa fa-circle-xmark" aria-hidden="true"></i>
          </button>
        )}
      </div>
    </section>
  );
};

export default AncienAmbassadorSection;